import { form } from './form'
import { modal } from './modal'
import { logo } from './logo'
import { role } from './role'
import { operatingSystem } from './operatingSystem'
import { browser } from './browser'
import { device } from './device'
import integrations from './integration'
import { misc } from './misc'

const SVG = { form, logo, modal, role, operatingSystem, browser, device, integrations, misc }
export default SVG
